import { useState, useCallback } from "react";
import type {
  IntroductionLetterTemplate,
  TemplateFormData,
} from "../types/introduction-letter";

export const useIntroductionLetterTemplates = () => {
  const [templates, setTemplates] = useState<IntroductionLetterTemplate[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTemplates = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // Simulate API call - replace with actual API endpoint
      const mockTemplates: IntroductionLetterTemplate[] = [
        {
          id: "1",
          name: "Formal Proposal Introduction",
          category: "Funeral",
          body_template:
            "Dear {client_name},\n\nWe are honored to present this proposal for {event_title} in memory of {deceased_name}.",
        },
      ];
      setTemplates(mockTemplates);
    } catch (err) {
      setError("Failed to fetch templates");
    } finally {
      setLoading(false);
    }
  }, []);

  const saveTemplate = useCallback(async (data: TemplateFormData) => {
    setLoading(true);
    setError(null);
    try {
      // Simulate API call - replace with actual API endpoint
      const newTemplate: IntroductionLetterTemplate = {
        id: Date.now().toString(),
        ...data,
        created_at: new Date().toISOString(),
      };
      setTemplates((prev) => [...prev, newTemplate]);
    } catch (err) {
      setError("Failed to save template");
    } finally {
      setLoading(false);
    }
  }, []);

  const updateTemplate = useCallback(
    async (id: string, data: TemplateFormData) => {
      setLoading(true);
      setError(null);
      try {
        // Simulate API call - replace with actual API endpoint
        setTemplates((prev) =>
          prev.map((t) =>
            t.id === id
              ? { ...t, ...data, updated_at: new Date().toISOString() }
              : t
          )
        );
      } catch (err) {
        setError("Failed to update template");
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const deleteTemplate = useCallback(async (id: string) => {
    setLoading(true);
    setError(null);
    try {
      // Simulate API call - replace with actual API endpoint
      setTemplates((prev) => prev.filter((t) => t.id !== id));
    } catch (err) {
      setError("Failed to delete template");
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    templates,
    loading,
    error,
    fetchTemplates,
    saveTemplate,
    updateTemplate,
    deleteTemplate,
  };
};
